var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "18px",
    viewBox: "0 0 33 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicles",
    transform: "translate(-33.000000, -334.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(34.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12670898,14.4881592 L1,14.4881592 C0.44771525,14.4881592 0,14.0404439 0,13.4881592 L0,8.57885742 C0,8.02657267 0.44771525,7.57885742 1,7.57885742 L28,7.57885742 C29.6568542,7.57885742 31,8.92200317 31,10.5788574 L31,13.4881592 C31,14.0404439 30.5522847,14.4881592 30,14.4881592 L26.9748535,14.4881592 M21.9750977,14.4881592 L8.9206543,14.4881592",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4406254,1 L24.1906254,7 L5.79912069,7 L9.54912069,1 L20.4406254,1 Z",
    id: "Rectangle-Copy"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24.494873,
    cy: 14.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 6.49487305,
    cy: 14.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.494873,
    y1: 1.13574219,
    x2: 14.494873,
    y2: 6.47875977,
    id: "Path-44"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.b1cf44a8ef826694959781b8468e2a1a.svg";
export { ForwardRef as ReactComponent };